var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sidebar',_vm._l((_vm.realSignUpMenu),function(item){return _c('SidebarItem',{key:item.name,class:{disable_menu: item.disabled},attrs:{"slot":"links","link":item},slot:"links"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }